<div class="md3-surface content grid-1-auto">
  <!-- Loading Content -->
  <div *ngIf="isLoading" class="content" style="position: absolute; width: 100%">
    <div class="splash loading"><div class="spinner"><div></div><div></div><div></div><div></div></div></div>
  </div>
  <div *ngIf="!isLoading" class="app-reportbuilder content layout-auto-1">
    <!--Workflow Navigation-->
    <div class="md3-card-on-surface app-space-bottom wf-timeline">
      <div class="grid-auto-1-auto">
        <i (click)="navigateLeft()"
           [tooltip]="'Zurück'"
           flow="right"
           style="font-size: medium"
           [class.disabled]="wfConfig.selectedWorkflowIndex === 0"
           class="fal fa-arrow-left app-drawer-icon  wf-navigate"></i>
        <div class="grid cols-{{workflow.length}}  wf-grid">
          <ng-container *ngFor="let wf of workflow; index as i">
            <div class="stack-center">
              <i *ngIf="wf.progress === 100"
                 class="fa-duotone fa-solid fa-circle-check  wf-icon-full"></i>
              <div *ngIf="wf.progress !== 100" class="wf-navigation-point"></div>
              <div *ngIf="i > 0" class="wf-line-connector"></div>
              <div *ngIf="i < workflow.length - 1" class="wf-line-progress"
                   [ngStyle]="{'width': wf.progress + '%', 'background-color': wf.progress === 100 ? 'var(--c-green-400)' : 'var(--c-light-400)'}">
              </div>
              <span [ngStyle]="{'color': wfConfig.selectedWorkflowIndex === i ? 'var(--c-dark-400)' : 'var(--c-neutral-800)',
                        'font-weight': wfConfig.selectedWorkflowIndex === i ? '500' : '400' }">
                  {{wf.navigationName}}
              </span>
            </div>
          </ng-container>
        </div>
        <i (click)="navigateRight()"
           [tooltip]="'Weiter'"
           flow="left"
           style="font-size: medium"
           [class.disabled]="wfConfig.selectedWorkflowIndex === workflow.length - 1 || !canNavigateToNextStep()"
           class="fal fa-arrow-right app-drawer-icon  wf-navigate"></i>
      </div>
    </div>
    <!--Workflow Content-->
    <div class="md3-card-on-surface content">
      <!--DocSelection-->
      <div class="content" [style.display]="wfConfig.selectedWorkflowIndex !== 0 ? 'none' : 'block'">
        <app-report-doc-selector class="content"
                                 [insertSummaryData]="selectedSummary"
                                 [vorgOrAuNr]="vorgOrAuNr"
                                 [selectKey]="selectKey"
                                 (choseObj)="addChosenObject($event)"
                                 (deleteChosenObj)="deleteChosenObject($event)">
        </app-report-doc-selector>
      </div>
      <!--ReportArrangement-->
      <div class="content" [style.display]="wfConfig.selectedWorkflowIndex !== 1 ? 'none' : 'block'">
        <app-report-doc-arranger class="content" #docArranger
                                 [vorgOrAuNr]="vorgOrAuNr"
                                 [selectKey]="selectKey"
                                 [addObj]="objToAddInArranger"
                                 [deleteObj]="objToDeleteInArranger"
                                 (arrangementArrayChange)="onArrangerChanged($event)"
        >
        </app-report-doc-arranger>
      </div>
      <!--ReportResult-->
      <div class="content" [style.display]="wfConfig.selectedWorkflowIndex !== 2 ? 'none' : 'block'">
        <app-report-doc-result class="content" #docResult
                               [vorgOrAuNr]="vorgOrAuNr"
                               [aueSchadenNr]="aueSchadenNr"
                               [selectKey]="selectKey"
                               [auID]="auID"
                               [oeID]="oeID"
                               [taskList]="taskList"
                               [arrangedDocs]="sharedArrangedDocs"
                               [isVisible]="wfConfig.selectedWorkflowIndex === 2"
                               [tabinstance]="tabinstance"
        >
        </app-report-doc-result>
      </div>
    </div>
  </div>
<!--  &lt;!&ndash;Sidebar&ndash;&gt;-->
<!--  <div class="app-drawer md3-card-on-surface app-height-auto">-->
<!--    <i  *ngIf="!isLoading"-->
<!--        (click)="docResult.downloadReportDocPDF()"-->
<!--        class="fal fa-eye app-drawer-icon"-->
<!--        [tooltip]="'Download Berichtsentwurf'" flow="left"></i>-->
<!--  </div>-->
</div>
